import React, { useMemo } from "react";
import ReactDOM from "react-dom/client";
import "./core/theme/styles/index.css";
import "./core/theme/styles/footer.css";
import "./core/theme/styles/flipcard.css";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { createAppTheme } from "./core/theme/createAppTheme.ts";
import { store, useAppSelector } from "./core/redux/store.ts";
import { Provider } from "react-redux";
import Layout from "./core/components/layout/Layout.tsx";
import AppRoutes from "./core/routes/Routes.tsx";
import ErrorBoundary from "./core/components/common/ErrorBoundary.tsx";

function App() {
  const mode = useAppSelector((state) => state.theme.mode);
  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Layout>
        <AppRoutes />
      </Layout>
    </ThemeProvider>
  );
}

const rootElement = document.getElementById("root");
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ErrorBoundary>
        <Provider store={store}>
          <App />
        </Provider>
      </ErrorBoundary>
    </React.StrictMode>
  );
}
